import * as yup from 'yup'

export const validationSchema = yup.object({
  tipo: yup
    .string()
    .oneOf(['Pessoa', 'Curso', 'PessoaTipo'])
    .nullable()
    .required('O campo é obrigatório.'),
  alvos: yup
    .array()
    .of(yup.mixed())
    .min(1, 'Selecione ao menos um alvo.')
    .required('O campo é obrigatório.'),
  horarioMinimoSaida: yup.string().required('O campo é obrigatório.')
})
